import { defineMessages } from 'react-intl';

import CardsEdit from './CardsEdit';
import CardsView from './CardsView';
import { cardsSchema } from './schema';

import cardsSVG from '@plone/volto/icons/cards.svg';
defineMessages({
  cards: {
    id: 'Cards',
    defaultMessage: 'Cards',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.cardsBlock = {
    id: 'cardsBlock',
    title: 'Cards',
    group: 'layout',
    icon: cardsSVG,
    view: CardsView,
    edit: CardsEdit,
    blockSchema: cardsSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
